export const EmailRegularExpression = /^['a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$/;
export const PhoneRegularExpression = /^([(\-\s\.\+]*[0-9][)\-\s\.]*){5,15}$/;
